<div *ngIf="data" class="report-dialog-container">
  <mat-tab-group mat-align-tabs="start" class="full-height-tabs">
    <!-- INFO -->
    <mat-tab [label]="'map.sidebar.object_detail.info' | translate">
      <div class="mat-container">
        <div class="wrapper-data">
          <ng-container *ngFor="let item of data">
            <!-- Normal prop -->
            <ng-container *ngIf="!isArray(item.value) && !isObject(item.value)">
              <div class="wrapper-item">
                <div class="item-key">
                  {{ item.key.toString() | replace : '_' : ' ' }}
                </div>
                <div class="item-value">{{ item.value }}</div>
              </div>
            </ng-container>
            <!-- Array -->
            <ng-container *ngIf="isArray(item.value)">
              <!-- Array of object -->
              <div class="wrapper-full">
                <div class="item-key">
                  {{ item.key.toString() | replace : '_' : ' ' }}
                </div>

                <div class="wrapper-list">
                  <div *ngFor="let element of item.value; let i = index">
                    <hr />
                    <div class="wrapper-data">
                      <div *ngFor="let prop of element" class="wrapper-item">
                        <div class="item-key">
                          {{ prop.key.toString() | replace : '_' : ' ' }}
                        </div>
                        <div class="item-value">{{ prop.value }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- Object -->
            <ng-container *ngIf="isObject(item.value)">
              <div class="wrapper-item wrapper-full">
                <div class="item-key">
                  {{ item.key.toString() | replace : '_' : ' ' }}
                </div>

                <div class="wrapper-data">
                  <div *ngFor="let item of item.value | keyvalue" class="wrapper-item">
                    <div class="item-key">
                      {{ item.key.toString() | replace : '_' : ' ' }}
                    </div>
                    <div class="item-value">{{ item.value }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <!-- Lista sorgenti x WSZ -->
        <mat-list *ngIf="sorgenti?.length" class="wrapper-item">
          <div class="item-key">Sorgenti</div>
          <mat-list-item *ngFor="let sorgente of sorgenti" class="item-value">
            <div class="d-flex justify-content-between align-items-center">
              <div matListItemLine>{{ sorgente.search_term }}</div>
              <div>
                <button mat-icon-button (click)="showDetail(sorgente)">
                  <mat-icon>info_outline</mat-icon>
                </button>

                <button mat-icon-button (click)="evidence(sorgente)">
                  <mat-icon>filter_center_focus</mat-icon>
                </button>
              </div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>
    </mat-tab>

    <!-- @author Tommaso Lazzaretti - G4B-169 - verticale PSA -->
    <mat-tab [label]="'map.sidebar.object_detail.psa' | translate" *ngIf="isSchemaIdropotabileObject() && isPSAEnabled">
      <div class="mat-container">
        <ebw-monorepo-psa-viewer [id]="id"></ebw-monorepo-psa-viewer>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
